import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/HomeView"),
  },
  {
    path: "/callus",
    component: () => import("@/views/callUs"),
  },
  {
    path: "/download",
    component: () => import("@/views/Download"),
  },
  {
    path: "/simulator",
    component: () => import("@/views/Simulator"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
